// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var RatingGroup$ReactHooksTemplate = require("./RatingGroup.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

function RatingGroupEditor(props) {
  var onRatingGroupChange = props.onRatingGroupChange;
  var ratingGroup = props.ratingGroup;
  var compareRatingGroups = Belt_List.cmpByLength(RatingGroup$ReactHooksTemplate.nonEmptyGroups(ratingGroup), RatingGroup$ReactHooksTemplate.groups(ratingGroup));
  var hasInvalidChoice = compareRatingGroups !== 0;
  var count = RatingGroup$ReactHooksTemplate.answerRequirement(ratingGroup);
  var match;
  if (typeof count !== "object") {
    match = [
      undefined,
      undefined
    ];
  } else {
    switch (count.TAG) {
      case "AtLeast" :
          match = [
            count._0,
            undefined
          ];
          break;
      case "AtMost" :
          match = [
            undefined,
            count._0
          ];
          break;
      case "Exactly" :
          var count$1 = count._0;
          match = [
            count$1,
            count$1
          ];
          break;
      case "Range" :
          match = [
            count._0,
            count._1
          ];
          break;
      
    }
  }
  var currentMax = match[1];
  var currentMin = match[0];
  var getRequirementFromMinMax = function (min, max) {
    if (min !== undefined) {
      if (max !== undefined) {
        if (min === max) {
          return {
                  TAG: "Exactly",
                  _0: min
                };
        } else {
          return {
                  TAG: "Range",
                  _0: min,
                  _1: max
                };
        }
      } else {
        return {
                TAG: "AtLeast",
                _0: min
              };
      }
    } else if (max !== undefined) {
      return {
              TAG: "AtMost",
              _0: max
            };
    } else {
      return "All";
    }
  };
  var updateRequirement = function (newMin, newMax) {
    var newRequirement = getRequirementFromMinMax(newMin, newMax);
    Curry._1(onRatingGroupChange, RatingGroup$ReactHooksTemplate.setAnswerRequirement(ratingGroup, newRequirement));
  };
  var count$2 = RatingGroup$ReactHooksTemplate.answerRequirement(ratingGroup);
  var tmp;
  if (typeof count$2 !== "object") {
    tmp = "All groups must be answered";
  } else {
    switch (count$2.TAG) {
      case "AtLeast" :
          tmp = "At least " + String(count$2._0) + " groups";
          break;
      case "AtMost" :
          tmp = "At most " + String(count$2._0) + " groups";
          break;
      case "Exactly" :
          tmp = "Exactly " + String(count$2._0) + " groups";
          break;
      case "Range" :
          tmp = "Range Between " + String(count$2._0) + " min and max " + String(count$2._1) + " groups";
          break;
      
    }
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Answer Requirement",
                              className: "text-darkcharcoal text-sm font-medium mb-2"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Minimum groups",
                                              className: "block text-xs text-gray-600 mb-1"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "bg-white border border-gray-400 rounded p-2 text-sm w-full",
                                              max: String(List.length(RatingGroup$ReactHooksTemplate.groups(ratingGroup))),
                                              min: "1",
                                              placeholder: "Min",
                                              type: "number",
                                              value: currentMin !== undefined ? String(currentMin) : "",
                                              onChange: (function ($$event) {
                                                  var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                                  if (!(value === "" || Caml_format.int_of_string(value) <= List.length(RatingGroup$ReactHooksTemplate.groups(ratingGroup)))) {
                                                    return ;
                                                  }
                                                  var newMin = value === "" ? undefined : Caml_format.int_of_string(value);
                                                  updateRequirement(newMin, currentMax);
                                                })
                                            })
                                      ],
                                      className: "w-1/2"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Maximum groups",
                                              className: "block text-xs text-gray-600 mb-1"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "bg-white border border-gray-400 rounded p-2 text-sm w-full",
                                              max: String(List.length(RatingGroup$ReactHooksTemplate.groups(ratingGroup))),
                                              min: "1",
                                              placeholder: "Max",
                                              type: "number",
                                              value: currentMax !== undefined ? String(currentMax) : "",
                                              onChange: (function ($$event) {
                                                  var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                                  if (!(value === "" || Caml_format.int_of_string(value) <= List.length(RatingGroup$ReactHooksTemplate.groups(ratingGroup)))) {
                                                    return ;
                                                  }
                                                  var newMax = value === "" ? undefined : Caml_format.int_of_string(value);
                                                  updateRequirement(currentMin, newMax);
                                                })
                                            })
                                      ],
                                      className: "w-1/2"
                                    })
                              ],
                              className: "flex gap-2"
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp,
                              className: "mt-2 text-xs text-gray-600"
                            })
                      ],
                      className: "mb-4 pb-4 border-b border-gray-300"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Color Coded Star",
                                    className: "text-darkcharcoal text-sm font-medium"
                                  }),
                              JsxRuntime.jsxs("label", {
                                    children: [
                                      JsxRuntime.jsx("input", {
                                            checked: RatingGroup$ReactHooksTemplate.isColorCoded(ratingGroup),
                                            type: "checkbox",
                                            onChange: (function (param) {
                                                var newRepresentationType = RatingGroup$ReactHooksTemplate.isColorCoded(ratingGroup) ? "SingleColor" : "ColorCode";
                                                Curry._1(onRatingGroupChange, RatingGroup$ReactHooksTemplate.setRepresentationType(ratingGroup, newRepresentationType));
                                              })
                                          }),
                                      JsxRuntime.jsx("span", {
                                            className: "slider round"
                                          })
                                    ],
                                    className: "switch"
                                  })
                            ],
                            className: "flex justify-between"
                          }),
                      className: "mb-4 pb-4 border-b border-gray-300"
                    }),
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    src: Image$ReactHooksTemplate.plusCircle
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "Add option"
                                  })
                            ],
                            className: "flex items-center justify-between gap-1 text-darkcharcoal"
                          }),
                      className: "bg-ghostwhite border border-gray-400\n            flex rounded p-2 text-sm mt-0" + (
                        hasInvalidChoice ? " disabled-input" : " "
                      ),
                      disabled: hasInvalidChoice,
                      onClick: (function (param) {
                          Curry._1(onRatingGroupChange, RatingGroup$ReactHooksTemplate.setGroups(ratingGroup, Belt_List.concat({
                                        hd: [
                                          RandomId$ReactHooksTemplate.toString(RandomId$ReactHooksTemplate.generate()),
                                          ""
                                        ],
                                        tl: /* [] */0
                                      }, RatingGroup$ReactHooksTemplate.groups(ratingGroup))));
                        })
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(List.mapi((function (i, param) {
                                  var choice = param[1];
                                  var groupId = param[0];
                                  return JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("div", {
                                                            children: "Label " + String(i + 1 | 0),
                                                            className: "sb-choice-label text-darkcharcoal text-sm font-medium"
                                                          }),
                                                      JsxRuntime.jsx("input", {
                                                            className: (
                                                              choice === "" ? "h-40-px py-2 px-4 rounded bg-white border border-red-500 focus:border-red-500 text-xs w-full" : "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full"
                                                            ) + " sb-choice-input",
                                                            placeholder: "Enter Label " + String(i + 1 | 0),
                                                            type: "text",
                                                            value: choice,
                                                            onChange: (function ($$event) {
                                                                var value = Utils$ReactHooksTemplate.formTargetValue($$event);
                                                                Curry._1(onRatingGroupChange, RatingGroup$ReactHooksTemplate.setGroups(ratingGroup, List.map((function (group) {
                                                                                var id = group[0];
                                                                                if (id === groupId) {
                                                                                  return [
                                                                                          id,
                                                                                          value
                                                                                        ];
                                                                                } else {
                                                                                  return group;
                                                                                }
                                                                              }), RatingGroup$ReactHooksTemplate.groups(ratingGroup))));
                                                              })
                                                          }),
                                                      JsxRuntime.jsx("img", {
                                                            className: "sb-choice-delete h-12-px cursor-pointer",
                                                            src: Image$ReactHooksTemplate.trash,
                                                            onClick: (function (param) {
                                                                Curry._1(onRatingGroupChange, RatingGroup$ReactHooksTemplate.removeGroup(groupId, RatingGroup$ReactHooksTemplate.groups(ratingGroup), ratingGroup));
                                                              })
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: "Label can't be blank",
                                                            className: choice === "" ? "sb-choice-error text-red-500 text-xs" : "hidden"
                                                          })
                                                    ],
                                                    className: "mb-4 sb-choice-row"
                                                  })
                                            });
                                }), List.rev(RatingGroup$ReactHooksTemplate.groups(ratingGroup)))),
                      className: "mb-7 mt-4"
                    })
              ]
            });
}

var make = RatingGroupEditor;

exports.make = make;
/* react/jsx-runtime Not a pure module */
